import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'
import { WidgetComponent } from 'modules/desktop/modules/widgets/types/widgets.types'

import { WidgetWrapper } from '../../../WidgetWrapper'

export const CalendarMediumWidget: WidgetComponent = ({ ...widgetProps }) => {
  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_CALENDAR_APP_DEV_PATH,
    'calendar',
    './CalendarMediumWidget',
    'calendarApp'
  )
  // @ts-expect-error: dynamic import
  const { CalendarMediumWidgetExposed: CalendarMediumWidget } =
    isLoaded && !isError && !missingRemoteUrl && module
      ? module
      : {
          CalendarMediumWidgetExposed: () => <></>
        }
  return (
    <WidgetWrapper {...widgetProps} isLoading={!isLoaded}>
      <CalendarMediumWidget />
    </WidgetWrapper>
  )
}
